import React, { useEffect, useState } from "react";
import BookingDetalisListSideNavigation from "../../components/Layouts/ReservationsCard/BookingDetalisListSideNavigation";
import { BookingApi } from "../../API/Apis/BookingApi";
import NotAuthorisedPage from "../notAuthorisedPage";
import InvoiceCard from "./InvoiceCard";
import { t } from "i18next";
import { AppStandardButton } from "../../components/UI/AppButtons";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import BookingGetters from "../../store/onlineBooking/getters";
import CollapsibleNavbar from "../../components/Layouts/ReservedAreaDashboard/CollapseNavbar";
import { useTranslation } from "react-i18next";
import i18n from "../../config/i18n";

export default function MyInvoices() {
  const AppSettings = BookingGetters.getAppSettings();
  const [showInvoices, setShowInvoices] = useState(false);

  const [bookCarData, setBookCarData] = useState("");
  const [showSearchText, setShowSearchText] = useState("");

  const { t: translate } = useTranslation();
  const locationLang = i18n.language;

  const textResourceDetails =
    BookingGetters.getTextResourceDetailsBasedOnLang();
  const textResourceData =
    textResourceDetails?.[locationLang]?.flatMap((item) => item.data || []) ||
    [];
  useEffect(() => {
    const bookingCarTextData = textResourceData.find(
      (item) => item.key === "bookCar"
    );
    setBookCarData(bookingCarTextData?.body || t("Book a car"));
    const showSearchTextData = textResourceData.find(
      (item) => item.key === "searchInvoiceText"
    );
    setShowSearchText(showSearchTextData?.body || t("Search Invoice"));
  }, [textResourceData, locationLang, translate]);
  useEffect(() => {
    setShowInvoices(!!AppSettings?.reservedArea);
  }, [AppSettings]);
  const [searchInvoice, setSearchInvoice] = useState("");

  const setSearchInvoiceValue = (event) => {
    setSearchInvoice(event.target.value);
  };
  const isSmallScreen = window.innerWidth <= 768;
  const istabletScreen = window.innerWidth > 768 && window.innerWidth < 1300;
  return (
    <div>
      {showInvoices && (
        <div className="flex-row md:flex">
          {!isSmallScreen && !istabletScreen && (
            <div className="!w-780" style={{ width: "300px" }}>
              <BookingDetalisListSideNavigation />
            </div>
          )}
          {(isSmallScreen || istabletScreen) && (
            <CollapsibleNavbar callFrom="showReservations" />
          )}
          <div
            className="rounded-sm pt-0 md:pt-12"
            style={
              istabletScreen
                ? { width: "100%" }
                : isSmallScreen
                ? { width: "" }
                : { width: "75%" }
            }
          >
            <div
              className={`${
                isSmallScreen ? "p-4" : "px-8"
              } text-[#333] max-w-screen-xl m-auto`}
            >
              {/*<div className="text-[#333] px-8 max-w-screen-xl m-auto">*/}
              <div className="flex justify-between items-center">
                <p className="text-[24px] font-medium leading-snug whitespace-nowrap">
                  {t("Invoice List")}
                </p>
                <div className="flex items-center">
                  {!isSmallScreen && (
                    <>
                      <TextField
                        label={showSearchText}
                        variant="outlined"
                        className="mr-4"
                        value={searchInvoice}
                        onChange={setSearchInvoiceValue}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment
                              position="start"
                              style={{ cursor: "pointer" }}
                            >
                              <Search />
                            </InputAdornment>
                          ),
                          style: {
                            height: "40px",
                            borderRadius: "10px",
                            paddingRight: "5px",
                          },
                        }}
                      />

                      <AppStandardButton
                        href="/"
                        className="ml-4"
                        variant="contained"
                        style={{
                          width: "150px",
                          backgroundColor: "primary",
                          borderRadius: "10px",
                        }}
                      >
                        <span className="normal-case">{bookCarData}</span>
                      </AppStandardButton>
                    </>
                  )}
                  {isSmallScreen && (
                    <AppStandardButton
                      href="/"
                      className={"flex"}
                      variant="contained"
                      style={{
                        width: "150px",
                        // marginLeft: "20px",
                        borderRadius: "10px",
                      }}
                    >
                      <span className="normal-case">{bookCarData}</span>
                    </AppStandardButton>
                  )}
                </div>
              </div>
              <p className="text-[#838181] text-[16px]">
                {t("View all your Invoices here.")}
              </p>
            </div>

            {isSmallScreen && (
              <div className="p-4">
                <TextField
                  label={showSearchText}
                  variant="outlined"
                  value={searchInvoice}
                  onChange={setSearchInvoiceValue}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ cursor: "pointer" }}
                      >
                        <Search />
                      </InputAdornment>
                    ),
                    style: {
                      height: "40px",
                      borderRadius: "10px",
                      paddingRight: "5px",
                    },
                  }}
                />
              </div>
            )}

            <div className="p-4">
              <InvoiceCard searchInvoice={searchInvoice} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
